/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetK12DistrictQueryResponse,
  GetK12DistrictPathParams,
  GetK12District404,
} from '../../types/GetK12District'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getK12District } from '../../clients/getK12District'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getK12DistrictQueryKey = ({
  id,
}: {
  id: GetK12DistrictPathParams['id']
}) => [{ url: '/api/v1/k12/districts/:id/', params: { id: id } }] as const

export type GetK12DistrictQueryKey = ReturnType<typeof getK12DistrictQueryKey>

export function getK12DistrictQueryOptions(
  { id }: { id: GetK12DistrictPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getK12DistrictQueryKey({ id })
  return queryOptions<
    GetK12DistrictQueryResponse,
    ResponseErrorConfig<GetK12District404>,
    GetK12DistrictQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getK12District(
        { id: id },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @summary Get K-12 district detail
 * {@link /api/v1/k12/districts/:id/}
 */
export function useGetK12District<
  TData = GetK12DistrictQueryResponse,
  TQueryData = GetK12DistrictQueryResponse,
  TQueryKey extends QueryKey = GetK12DistrictQueryKey,
>(
  { id }: { id: GetK12DistrictPathParams['id'] },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetK12DistrictQueryResponse,
        ResponseErrorConfig<GetK12District404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getK12DistrictQueryKey({ id })

  const query = useQuery(
    {
      ...getK12DistrictQueryOptions({ id }, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<GetK12District404>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
